import styled from 'styled-components';
import theme from '../../../../styles/theme';
import NaviText from '../../common/NaviText';
import React, { useState, useCallback } from 'react';
import { Row } from '../../../../styles/common';
import { FormControl, InputLabel, TextField, Select, MenuItem, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { useSetClient } from '../../../../interface/common';
import Button from '../../../common/Button';

const MainWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    .label {
        padding: 4px;
        min-width: 8rem;
        height: calc(100% - 8px);
        font-size:${theme.fontSize.base};
    }
    .naviBar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid ${theme.color.black[10]};
        position:sticky;
        top:0px;
        background: ${theme.color.white[100]};
        z-index:1500;
    }
`;

const ClientForm = ({target, onClose}) => {

    // const {data : userDeptList} = useGetCodeList('user_dept');
    // const {data : userTpList} = useGetCodeList('user_tp');

    const {mutate} = useSetClient();

    const [client, setClient] = useState({...target});

    const handleAddClick = useCallback((addItem) => {
        const temp = {
            mode: 'POST',
            cnm: addItem.cnm,
            biz_no: addItem.biz_no,
            phn_no: addItem.phn_no,
            owner: addItem.owner,
            addr: addItem.addr,
            descr: addItem.descr,
            is_gov: addItem.is_gov,
            is_use:1
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })
    const handleModClick = useCallback((modItem) => {
        const temp = {
            mode: 'PUT',
            cid: modItem.cid,
            cnm: modItem.cnm,
            biz_no: modItem.biz_no,
            phn_no: modItem.phn_no,
            owner: modItem.owner,
            addr: modItem.addr,
            descr: modItem.descr,
            is_gov: modItem.is_gov,
            is_use:1
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })
    const handleDelClick = useCallback((delItem) => {
        const temp = {
            mode: 'DELETE',
            cid: delItem.cid,
        }
        mutate(
            temp,
            {
                onSuccess:()=>{
                    onClose && onClose();
                }
            }
            )
    })

    const handleValueChange = (id, val) => {
        const temp  = {...client,[id]:val}
        setClient(temp);
    }

    return (
        <MainWrap>
            <div className='naviBar'>
                <NaviText target={[{text:'설정'},{text:'거래처관리'}]} />
                <div className='close' onClick={()=>onClose(false)}>
                    <img src={`/images/ic_close.svg`} />
                </div>
            </div>
            <div style={{flexGrow:1,marginTop:'8px'}}>
                <Row>
                    <TextField 
                        id='cnm' 
                        label='거래처명' 
                        style={{width:'25rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.cnm}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='biz_no' 
                        label='사업자 번호' 
                        style={{width:'12rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.biz_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='phn_no' 
                        label='전화번호' 
                        style={{width:'12rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.phn_no}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <TextField 
                        id='owner' 
                        label='대표자명' 
                        style={{width:'15rem'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.owner}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="is_gov-label"
                            defaultValue={client && client.is_gov}
                            name="is_gov"
                            onChange={(e)=>{console.log(e.target.id,e.target.value);handleValueChange('is_gov',e.target.value)}}
                        >
                            <FormControlLabel value={0} control={<Radio />} label="일반" />
                            <FormControlLabel value={1} control={<Radio />} label="기관" />
                        </RadioGroup>
                    </FormControl>
                </Row>
                <Row>
                    <TextField 
                        id='addr' 
                        label='주소' 
                        style={{width:'100%'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.addr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                <Row>
                    <TextField 
                        id='descr' 
                        label='설명' 
                        style={{width:'100%'}} 
                        size='small' 
                        InputLabelProps={{shrink:true}} 
                        defaultValue={client && client.descr}
                        onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                    />
                </Row>
                {!target ? 
                    <Row>
                        <Button onClick={()=>handleAddClick(client)} style={{ margin:0 }}>등록</Button>
                    </Row>
                :
                    <React.Fragment>
                        <Row style={{display:'grid',gridTemplateColumns:'1fr 1fr'}}>
                            <Button onClick={()=>handleModClick(client)} style={{ margin:0 }}>수정</Button>
                            <Button onClick={()=>handleDelClick(client)} style={{ margin:0 }}>삭제</Button>
                        </Row>
                    </React.Fragment>
                }
            </div>
        </MainWrap>
    )
    
}

export default ClientForm;